// extracted by mini-css-extract-plugin
export default {"app":"Layout_app__oBVd2","main":"Layout_main__L7jjn"};